import { render, staticRenderFns } from "./RequestTable.vue?vue&type=template&id=0d99585a&scoped=true"
import script from "./RequestTable.vue?vue&type=script&lang=js"
export * from "./RequestTable.vue?vue&type=script&lang=js"
import style0 from "./RequestTable.vue?vue&type=style&index=0&id=0d99585a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d99585a",
  null
  
)

export default component.exports